import authRequest from "@/api/http/authRequest";


export default {
  search (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.get(`/admin/product/lesson/search`, params, cb, errCb)
  },
  updateStatus (id: number, cb: (response) => void, errCb: (response) => any) {
    authRequest.put(`/admin/product/lesson/${id}/status`, {} ,cb, errCb)
  },
  update (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/product/lesson/${params.id}`, params ,cb, errCb)
  },
  save (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/product/lesson`, params,cb, errCb)
  },
  delete (id: number, cb: (response) => void, errCb: (response) => any) {
    authRequest.delete(`/admin/product/lesson/${id}`, cb, errCb)
  },
}
